import type { FC } from "react";
import { useState } from "react";

import ChevronDown from "@/assets/icons/chevron-down";
import ChevronUp from "@/assets/icons/chevron-up";
import Edit from "@/assets/icons/edit";
import { Button } from "@/components/ui/button";
import type { Allergy, Pathology, WomenHealth } from "@/types/api/patient";
import { getHealthLabel } from "@/utils/patient";

type GeneralHealthDropButtonProps = {
  mode: "pathology" | "allergy" | "womenHealth";
  values: Array<Allergy> | Array<Pathology> | Array<WomenHealth>;
  comment?: string;
  setHealthModalOpen: React.Dispatch<
    React.SetStateAction<"pathology" | "allergy" | "womenHealth" | "none">
  >;
};

const getLabel = (mode: "pathology" | "allergy" | "womenHealth") => {
  switch (mode) {
    case "pathology":
      return "Pathologies associées";
    case "allergy":
      return "Allergies";
    case "womenHealth":
      return "Santé de la femme";
  }
};

const GeneralHealthDropButton: FC<GeneralHealthDropButtonProps> = ({
  mode,
  values,
  comment,
  setHealthModalOpen,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="flex flex-col border-b border-gray-200">
      {values.length !== 0 ? (
        <Button
          type={"button"}
          variant={"text"}
          className={"w-full justify-between pb-[10px] px-0"}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {<div className="text-black">{getLabel(mode)}</div>}
          {isDropdownOpen ? <ChevronUp /> : <ChevronDown />}
        </Button>
      ) : (
        <div className="flex justify-between py-[10px]">
          {
            <div className="text-black text-sm font-semibold">
              {getLabel(mode)}
            </div>
          }
          <Button
            type="button"
            variant="text"
            className="text-brand-800 gap-[2px]"
            size={"none"}
            onClick={() => setHealthModalOpen(mode)}
          >
            <Edit color="#8470FF" className="w-5 h-5" />
            <div className="font-semibold px-[2px]">Compléter</div>
          </Button>
        </div>
      )}
      {values.length !== 0 && isDropdownOpen ? (
        <div className="flex flex-col pb-[10px] pl-2">
          {values.map((elem) => (
            <div
              className="text-black font-normal text-sm"
              key={`dropdown-${mode}-${elem.toLowerCase()}`}
            >
              {getHealthLabel(elem)}
              {elem === "OTHER" ? `: ${comment}` : null}
            </div>
          ))}
          <div className="flex justify-end">
            <Button
              type="button"
              variant="text"
              className="text-brand-800 gap-[2px] pt-2"
              size={"none"}
              onClick={() => setHealthModalOpen(mode)}
            >
              <Edit color="#8470FF" className="w-5 h-5" />
              <div className="font-semibold px-[2px]">Modifier</div>
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default GeneralHealthDropButton;
